import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import { RiAddBoxLine } from "react-icons/ri";
import AddAddress from "./AddAddress";
import EditAddress from "./EditAddress";
import Swal from "sweetalert2";
import "react-confirm-alert/src/react-confirm-alert.css";

const MyAddress = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editAddress, setEditAddress] = useState(null);

  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const user_auto_id = sessionStorage.getItem("accessToken");
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");


  useEffect(() => {
  const storedStyle = sessionStorage.getItem("UIStyle");
  if (storedStyle) {
    const parsedStyle = JSON.parse(storedStyle);
    setWebFont(parsedStyle.web_font);
    setThemeColor(parsedStyle.web_theme_colour)
  }
}, []);
function lightenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) + 255 * percent;
  let g = ((num >> 8) & 0x00ff) + 255 * percent;
  let b = (num & 0x0000ff) + 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}

function darkenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) - 255 * percent;
  let g = ((num >> 8) & 0x00ff) - 255 * percent;
  let b = (num & 0x0000ff) - 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}


  const fetchAddresses = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_user_address`,
        {
          admin_auto_id,
          user_auto_id,
          limit: 10,
          page_number: 1,
        }
      );
      setAddresses(res.data.status === 1 ? res.data.user_address_details : []);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  if (showAddForm) {
    return (
      <AddAddress
        onBack={() => setShowAddForm(false)}
        refreshAddresses={fetchAddresses}
      />
    );
  }

  if (editAddress) {
    return (
      <EditAddress
        existingData={editAddress}
        onBack={() => setEditAddress(null)}
        refreshAddresses={fetchAddresses}
      />
    );
  }

  const handleEdit = (address) => {
    setEditAddress(address);
  };

  const handleDelete = (address_auto_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this address?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/delete_user_address`,
            {
              admin_auto_id,
              user_auto_id,
              address_auto_id,
            }
          );

          if (res.data.status === 1) {
            fetchAddresses();
          } else {
           console.log(res.data.message || "Failed to delete address");
          }
        } catch (error) {
          console.error("Delete error:", error);

        }
      }
    });
  };

  return (
    <>
      <div className={`p-6 ${webFont}`}>
        {/* Header Section */}
        <div className="flex items-center justify-between px-6 py-2 mb-6 bg-white border border-gray-200 rounded-lg shadow-sm">
          <h2 className="text-xl font-bold">User Address</h2>
        </div>
        <div className="mt-4">
          <div className="flex-col gap-6 p-4 sm:flex md:flex-row sm:p-6 md:p-8">
            <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-3">
              <div
                className="flex flex-col items-center justify-center w-full h-56 py-10 transition border border-gray-300 cursor-pointer hover:bg-slate-100"
                onClick={() => setShowAddForm(true)}
              >
                <span className="text-4xl">+</span>
                <p className="font-semibold text-black">Add New Address</p>
              </div>

              {loading ? (
                <div className="flex items-center justify-center w-full h-56 col-span-1 text-gray-500 border border-gray-300">
                  Loading...
                </div>
              ) : addresses.length === 0 ? (
                <div className="flex items-center justify-center w-full h-56 col-span-1 text-gray-500 border border-gray-300">
                  No address found.
                </div>
              ) : (
                addresses.map((address, index) => (
                  <div
                    key={address._id}
                    className="w-full h-56 p-4 transition border border-gray-300 hover:bg-slate-100"
                    
                  >
                    <div className="flex justify-between">
                      <p className="font-semibold capitalize">
                        {address.address_type}- ({address.name})
                      </p>
                    </div>
                    <p className="mt-1 mb-0 text-gray-500 capitalize">
                      {address.flat_no} {address.wing_block_phase}{" "}
                      {address.address_details}, {address.area}, {address.state}
                    </p>
                    <p className="mb-0 text-gray-500 capitalize">
                      {address.city}-{address.pincode}, {address.country}
                    </p>
                    <p className="mb-0 text-gray-500 ">{address.mobile_no}</p>
                    <div className="flex space-x-4 sm:mt-2 md:mt-4">
                      <button
                        className="px-4 py-2 border border-gray-400 sm:py-1"
                        onClick={() => handleEdit(address)}
                      >
                        Edit
                      </button>
                      <button
                        className="px-4 py-2 text-white "
                        onClick={() => handleDelete(address._id)}
                        style={{backgroundColor:themeColor}}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default MyAddress;
